module.exports = __webpack_public_path__ + "static/media/06-contact.b956bc78.png";